<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <navbar
          isBlur="blur  border-radius-lg my-3 py-2 start-0 end-0 mx-4 shadow"
          v-bind:darkMode="true"
          isBtn="bg-gradient-success"
        />
      </div>
    </div>
  </div>
  <br><br><br><br><br><br>
  <main>
    <div class="py-4 container-fluid">

      <div class="card shadow-lg mt-n6">
        <div class="card-body p-3">
          <div class="row gx-4">
            <div class="col-auto">
              <div class="avatar avatar-xl position-relative">
                <i class="ni ni-album-2 text-dark text-sm opacity-10"></i>
              </div>
            </div>
            <div class="col-auto my-auto">
              <div class="h-100">
                <h5 class="mb-1">Carrier</h5>

                <p class="mb-0 font-weight-bold text-sm"></p>
              </div>
            </div>
            <div
              class="mx-auto mt-3 col-lg-4 col-md-6 my-sm-auto ms-sm-auto me-sm-0"
            >
              <div class="nav-wrapper position-relative end-0">
                <ul
                  class="p-1 bg-transparent nav nav-pills nav-fill"
                  role="tablist"
                >

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-8">
          <div class="card">
            <form id="form" role="form" method="POST">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">{{message}}</p>
                <argon-button color="success" size="sm" class="ms-auto" @click.prevent="submitData()"
                  >Save</argon-button
                >
                <router-view></router-view>
              </div>
            </div>
            <div class="card-body">
              
              <div class="row">

              <div class="col-md-10">
                  <label for="carrier" class="form-control-label"
                    >Carrier Name
                  </label><br>
                  <span class="td11">
                    <input class="form-control form-control-default invalid" id="name" name="name" type="text" :value="elements[0].name"/>
                  </span>
                  
              </div>

              <div class="card-header pb-0">
                  <div class="d-flex align-items-center">
                    <p id="message" name="message" class="text-dark font-weight-bolder">Carrier Rates</p>
                    <argon-button color="success" size="sm" class="ms-auto" @click.prevent="newelement('CarrierRate')">Create Carrier Rate</argon-button>
                  </div>
                    <ul class="ul">  
                      <li v-for="element in my_carrier_rates" :value="element.id" :key="element.id">
  
                        <span class="td1">
                          <router-link :to="{ name: 'CarrierRate', params: {id: element.id}}" class="font-weight-bold">
                            <i class="fa fa-ellipsis-v text-xs"></i>
                            &nbsp;<a
                            href="#"
                            class="text-secondary font-weight-bold text-xs"
                            data-toggle="tooltip">Edit</a>
                          </router-link>
                        </span>
                        {{ element.carrier }} {{ element.contract_type }} {{ element.rate_type }} {{ element.rate }} {{ new Date(element.effective_from).toLocaleDateString() }} - {{ new Date(element.effective_to).toLocaleDateString() }}

                      </li>
                    </ul>
                </div>

            </div>
            </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import router from "@/router";
import setTooltip from "@/assets/js/tooltip.js";
import Navbar from "@/examples/PageLayout/NavbarLoggedin.vue";
import ArgonButton from "@/components/ArgonButton.vue";

var message = "Carrier";

export default {
  name: "Carrier",
  props: ['id'],
  data() {
    return {
      showMenu: false,
      elements: [{id:0}],
      my_carrier_rates: [],
      message
    }
  },
  computed: {
    formattedDate(dt) {
      return new Date(dt).toLocaleDateString();
    },
    isFYMAdmin() {
      return this.role === 'FYM Admin';
    },
    isAgencyAdmin() {
      return this.role === 'Agency Admin';
    },
    isAgentManager() {
      return this.role === 'Agent Manager';
    },
    isAgent() {
      return this.role === 'Agent';
    }
  },
  methods: {
    serializeForm(){
      
      let myForm = document.getElementById('form'); 
      let formData = new FormData(myForm);
      const data = {}; 
      // need to convert it before using not with XMLHttpRequest
      for (let [key, val] of formData.entries()) {
            Object.assign(data, {[key]: val})
      }
      return(data);
    },
    async checkAuth() {
      let response = await fetch("/apis/auth");
      this.loggedin = await response.json();
      if(this.loggedin =="notloggedin") {
        location.href="/home";
      }
    },
    async getData() {
        let response = await fetch("/apis/element_load/at_carriers/" + this.$route.params.id);
        this.elements = await response.json();
    },
    async getCarrierRates() {        
      let response = await fetch("/apis/view/CarrierRates/" + this.$route.params.id);
      this.my_carrier_rates = await response.json();
    },
    async newelement(type) {
      router.push({ name: type, params: {id: 0, agent_id: this.$route.params.id}});
    },
    submitData: function() {
      
      var action = 'create';
      var api = 'create/Carrier';
      var element_id = this.$route.params.id;

      if (element_id > 0) {
        action = 'update';
        api = 'update/Carrier/' + element_id;
      }

      fetch('/apis/element_' + api, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(this.serializeForm()),
     })
     
      .then((res) => res.json())
      .then((data) => {
        console.log(data.result);
        if (data.result === 'Carrier_' + action + 'd') {
          this.message = data.message;
          this.getData();
        }
        else {
          router.push('/');
        }
      })
      .catch((err) => console.log(err));
    },
  },
  components: { Navbar,  ArgonButton },
  created() {

    this.checkAuth();
    
    if (this.$route.params.id > 0) {
      this.getData();
      this.getCarrierRates();
    }
    else {
      this.elements[0].id = '0';
    }

  },
  mounted() {
    this.$store.state.isAbsolute = true;
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = false;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = false;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
  }
  
};
</script>